module.exports = __webpack_public_path__ + "img/electrical_engineering_splash.8e53d8d4.jpg";